import { useContext, useState, useCallback } from 'react';

import { WebSocketContext } from '../../websocket-context/websocket-provider';
import { IPortfolioPerformanceAccounts } from '../portfolio-performance.types';

const PORTFOLIO_PERFORMANCE_CREDENTIALS_ID = 'PORTFOLIO_PERFORMANCE_CREDENTIALS';

export const usePortfolioPerformanceCredentials = () => {
  const { sendMessage, subscribeToChannel, isConnected } = useContext(WebSocketContext);

  const [credentials, setCredentials] = useState<IPortfolioPerformanceAccounts[]>([]);
  const [loadingCredentials, setLoadingCredentials] = useState(false);
  const [errorCredentials, setErrorCredentials] = useState(false);

  const fetchCredentials = useCallback(() => {
    if (!isConnected) return;
    setLoadingCredentials(true);
    setErrorCredentials(false);

    sendMessage(
      JSON.stringify({
        jsonrpc: '2.0',
        id: PORTFOLIO_PERFORMANCE_CREDENTIALS_ID,
        method: 'portfolio_performance.accounts',
        params: {},
      }),
    );

    subscribeToChannel(PORTFOLIO_PERFORMANCE_CREDENTIALS_ID, (resp: any) => {
      setLoadingCredentials(false);
      if (resp.error) {
        setErrorCredentials(true);
      } else if (resp.result) {
        setCredentials(resp.result);
      }
    });
  }, [sendMessage, isConnected]);

  return { credentials, loadingCredentials, errorCredentials, fetchCredentials };
};
